import { motion } from "framer-motion"

export const ArticleSkeletonLoader = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 + index * 0.1 }}
          className="bg-gradient-to-br from-[#1e1b4b]/20 via-[#312e81]/15 to-[#4338ca]/10 backdrop-blur-xl border border-[#4f46e5]/20 rounded-2xl overflow-hidden"
          style={{
            boxShadow: "0 10px 30px rgba(79, 70, 229, 0.15), inset 0 1px 0 rgba(165, 180, 252, 0.1)",
          }}
        >
          {/* Image Skeleton */}
          <div className="relative overflow-hidden ">
            <motion.div
              className="w-full h-48 bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10"
              animate={{
                backgroundPosition: ["0% 0%", "100% 0%"],
              }}
              transition={{
                duration: 1.5,
                repeat: Number.POSITIVE_INFINITY,
              }}
              style={{
                backgroundSize: "200% 100%",
              }}
            />
            <div className="absolute top-3 left-3">
              <motion.div
                className="w-16 h-6 bg-[#1e3a8a]/30 rounded-full"
                animate={{
                  backgroundPosition: ["0% 0%", "100% 0%"],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                }}
                style={{
                  backgroundSize: "200% 100%",
                }}
              />
            </div>
          </div>

          <div className="p-6">
            {/* Date and Read Time Skeleton */}
            <div className="flex items-center justify-between mb-3">
              <motion.div
                className="h-4 w-20 bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10 rounded"
                animate={{
                  backgroundPosition: ["0% 0%", "100% 0%"],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                }}
                style={{
                  backgroundSize: "200% 100%",
                }}
              />
              <motion.div
                className="h-4 w-24 bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10 rounded"
                animate={{
                  backgroundPosition: ["0% 0%", "100% 0%"],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                }}
                style={{
                  backgroundSize: "200% 100%",
                }}
              />
            </div>

            {/* Title Skeleton */}
            <motion.div
              className="h-6 w-full bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10 rounded mb-3"
              animate={{
                backgroundPosition: ["0% 0%", "100% 0%"],
              }}
              transition={{
                duration: 1.5,
                repeat: Number.POSITIVE_INFINITY,
              }}
              style={{
                backgroundSize: "200% 100%",
              }}
            />

            {/* Excerpt Skeleton (2 lines) */}
            <div className="mb-4 space-y-2">
              <motion.div
                className="h-4 w-full bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10 rounded"
                animate={{
                  backgroundPosition: ["0% 0%", "100% 0%"],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                }}
                style={{
                  backgroundSize: "200% 100%",
                }}
              />
              <motion.div
                className="h-4 w-5/6 bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10 rounded"
                animate={{
                  backgroundPosition: ["0% 0%", "100% 0%"],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                }}
                style={{
                  backgroundSize: "200% 100%",
                }}
              />
            </div>

            {/* Author Skeleton */}
            <div className="flex items-center mb-4">
              <motion.div
                className="w-8 h-8 rounded-full bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10 mr-3"
                animate={{
                  backgroundPosition: ["0% 0%", "100% 0%"],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                }}
                style={{
                  backgroundSize: "200% 100%",
                }}
              />
              <div className="flex-1">
                <motion.div
                  className="h-4 w-24 bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10 rounded mb-1"
                  animate={{
                    backgroundPosition: ["0% 0%", "100% 0%"],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Number.POSITIVE_INFINITY,
                  }}
                  style={{
                    backgroundSize: "200% 100%",
                  }}
                />
                <motion.div
                  className="h-3 w-32 bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10 rounded"
                  animate={{
                    backgroundPosition: ["0% 0%", "100% 0%"],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Number.POSITIVE_INFINITY,
                  }}
                  style={{
                    backgroundSize: "200% 100%",
                  }}
                />
              </div>
            </div>

            {/* Tags Skeleton */}
            <div className="flex flex-wrap gap-2 mb-4">
              <motion.div
                className="h-6 w-16 bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10 rounded"
                animate={{
                  backgroundPosition: ["0% 0%", "100% 0%"],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                }}
                style={{
                  backgroundSize: "200% 100%",
                }}
              />
              <motion.div
                className="h-6 w-20 bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10 rounded"
                animate={{
                  backgroundPosition: ["0% 0%", "100% 0%"],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                }}
                style={{
                  backgroundSize: "200% 100%",
                }}
              />
            </div>

            {/* Read More Button Skeleton */}
            <div className="flex justify-end">
              <motion.div
                className="h-5 w-24 bg-gradient-to-r from-[#4f46e5]/10 via-[#6366f1]/20 to-[#4f46e5]/10 rounded"
                animate={{
                  backgroundPosition: ["0% 0%", "100% 0%"],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                }}
                style={{
                  backgroundSize: "200% 100%",
                }}
              />
            </div>
          </div>
        </motion.div>
      ))}
    </>
  )
}
